module.exports = "<% code = code ? code : '418' %> <section class=\"http-status-code http-status-code--<%= code %>\"><h1><%= code %></h1></section>";